export * from './animated-logo.module';
